module.exports = __webpack_public_path__ + "img/service-icon2.6507687f.png";